import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import './ageRangeModal.css';
import CreateEdit from '../PolicyProduct/RiskFactor/Age/CreateEdit';

function AgeCreateModal({ handleClose, productId, setNewValue }) {
  return (
    <Dialog fullWidth={true} maxWidth={'lg'} open={true} onClose={handleClose}>
      <DialogContent className="modalContainer">
        <CreateEdit
          setNewValue={setNewValue}
          closeCreateEditForm={handleClose}
          ageEditDatas={null}
          editStatus={false}
          productId={productId}
        />
      </DialogContent>
    </Dialog>
  );
}

export default AgeCreateModal;
